import { useState } from 'react';
import '../Style/FAQ.css';

function Purchase() {
    const faqData = [
        {
            question: 'Riley Annual Subscription',
            answer: "The best value for new parents, with all the features!!",
            one: "• Save 33% annually (equivalent to 4 months free)",
            tow: "• Access Riley's full suite of tools for an entire year of support. Get access to all features, including:",
            thre: "• Golden Window predictive tool for tailored Sleep and Feeding schedules",
            four: "• 24/7 tailored parenting guidance via Riley's expert-trained chat",
            five: "• All-in-one integration: milestones, tracking, and recommendations",
            price: "119.9 $"
        },
        {
            question: "Riley Quarterly Subscription",
            answer: "Everything in the Monthly Plan—plus a lower rate!",
            one: "• Save 20% annually (equivalent to 3 months free)",
            tow: "• Enjoy stress-free parenting for less Get access to all features, including:",
            thre: "• Golden Window predictive tool for tailored Sleep and Feeding schedules",
            four: "• 24/7 tailored parenting guidance via Riley's expert-trained chat",
            five: "• All-in-one integration: milestones, tracking, and recommendations",
            price: "35 $"
        },
        {
            question: 'Riley Monthly Subscription',
            answer: "Get access to all membership features, including:",
            one: "• Powered by Golden Window predictive tool, Riley forecasts your baby's sleep and feed times for better rest and peace of mind.",
            tow: "• Enjoy stress-free parenting for less Get access to all features, including:",
            four: "• 24/7 tailored parenting guidance via Riley's expert-trained chat",
            five: "• All-in-one integration: milestones, tracking, and recommendations",
            price: "14 $"
        },
        {
            question: 'Custom Amount',
            answer: "Gift $75 Off to be used towards any purchase. The amount will apply to subscriptions until the gift card runs out!",
            price: "75 $"
        }
    ];

    const [openIndexes, setOpenIndexes] = useState([]);

    const toggleFAQ = (index) => {
        setOpenIndexes((prev) =>
            prev.includes(index)
                ? prev.filter((i) => i !== index)
                : [...prev, index]
        );
    };

    return (
        <div className="container-fluid row FAQ pt-2 pb-5 d-flex justify-content-center align-items-center m-0">
            {faqData.map((item, index) => (
                <div
                    key={index}
                    className="slider-cu shadow p-4 mb-4 col-lg-8 fw-bold"
                    onClick={() => toggleFAQ(index)}
                    style={{ cursor: 'pointer' }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <h4 className="m-0">{item.question}</h4>
                        <span style={{ fontSize: '24px', fontWeight: 'bold' }}>
                            {openIndexes.includes(index) ? '−' : '+'}
                        </span>
                    </div>

                    <div className={`faq-body mt-3 text-start ${openIndexes.includes(index) ? 'open' : ''}`}>
                        <p>{item.answer}</p>
                        {item.one && <p>{item.one}</p>}
                        {item.tow && <p>{item.tow}</p>}
                        {item.thre && <p>{item.thre}</p>}
                        {item.four && <p>{item.four}</p>}
                        {item.five && <p>{item.five}</p>}
                        <div className='row mt-3 align-items-center'>
                            <h3 className='col m-0'>{item.price}</h3>
                            <div className='btn-Purchase p-2 d-flex align-items-center justify-content-center text-white col-3 me-3'>
                                Purchase
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default Purchase;
